<template lang="pug">

	form
		div.form-group

			label.required Vetorização:

			div
				draw-button.col-md-12(@drawComplete="onGeometriaVetorizada", 
						:drawTool="drawTool", 
						name='drawButton', 
						:setDetails="true")

				div.invalid-field(v-show="erro") {{ erro }}

</template>

<script>

import InputErrors from '@/components/utils/InputErrors';
import DrawButton from '@/components/utils/DrawButton';
import TipoGeometria from '@/models/tipoGeometria';
import Estilo from '@/models/estilo';
import DrawUtils from '@/utils/drawUtils';
import MarkerStyles from '@/utils/markerStyles';
import LeafletUtils from '@/utils/leafletUtils';

export default {
	
	name: 'InspecaoGeometria',

	components: { InputErrors, DrawButton },

	props: {
		tipoGeometria: {
			type: Object,
			required: true
		},
		maxAreaHA: {
			type: Number,
			required: true
		}
	},

	data () {
		return {
			geometria: null,
			validacaoExecutada: false,
			drawTool: DrawUtils.POLYGON_TOOL,
			erro: null
		};
	},
	
	/**
	 * Configura o tipo de ferramenta de desenho de acordo com o tipo de Geometria
	 */
	created () {
		
		if (this.tipoGeometria.codigo === TipoGeometria.POLIGONO.codigo) {
			
			this.drawTool = DrawUtils.POLYGON_TOOL;

		} else if (this.tipoGeometria.codigo === TipoGeometria.LINHA.codigo) {

			this.drawTool = DrawUtils.POLYLINE_TOOL;

		} else if (this.tipoGeometria.codigo === TipoGeometria.PONTO.codigo) {

			this.drawTool = DrawUtils.CIRCLEMARKER_TOOL;
		}
	},

	methods: {

		inspecionarGeometria (geoJson) {

			var layer = LeafletUtils.createGeoJsonLayer(geoJson);
			
			if (layer.getLayers && layer.getLayers().length) {

				layer = layer.getLayers()[0];
			}

			this.onGeometriaVetorizada({ layer: layer });
		},

		/**
		 * Executado quando uma nova geometria é desenhada, remove a geometria anterior,
		 * adiciona a nova e executa as validações.
		 */
		onGeometriaVetorizada (data) {

			this.removerGeometriasMapa();
			this.geometria = data;

			if (this.tipoGeometria.codigo !== TipoGeometria.PONTO.codigo) {
				
				let style = Estilo.getStyleInspecao(this.tipoGeometria);
				data.layer.setStyle(style);

			} else {

				this.$mapa.removeLayer(this.geometria.layer);
				this.adicionarMarcador();
			}

			this.validar();
		},

		/**
		 * Utilizado no caso do tipo de geometria for PONTO, onde ao invés
		 * do desenho do ponto, é adicionado ao mapa o marcador de inspeção.
		 */
		adicionarMarcador () {

			let latlng = this.geometria.layer.getLatLng();

			this.$bus.$emit('mapa.addCoordinatePoint', {
				markerCode: 'InformacoesPonto',
				lat: latlng.lat,
				lng: latlng.lng,
				markerStyle: MarkerStyles.inspecao,
				center: false,
				fixed: true
			});
		},

		/**
		 * Remove as geometria do mapa. Utilizado quando o usuário alterna para outra
		 * ferramenta de inspeção ou limpa o formulário.
		 */
		removerGeometriasMapa () {

			if (this.tipoGeometria.codigo !== TipoGeometria.PONTO.codigo) {

				if (this.geometria) this.$mapa.removeLayer(this.geometria.layer);

			} else {

				this.$bus.$emit('mapa.removeCoordinatePoint', 'InformacoesPonto');
			}
		},

		/**
		 * Adiciona a geometria do mapa (se existente. Utilizado quando o usuário alterna
		 * para outra ferramenta de inspeção e retorna a esta.
		 */
		adicionarGeometriasMapa () {

			if (this.geometria) {

				if (this.tipoGeometria.codigo !== TipoGeometria.PONTO.codigo) {

					this.$mapa.addLayer(this.geometria.layer);
				
				} else {

					this.adicionarMarcador();
				}
			}
		},

		/**
		 * Valida se o usuário adicionou uma geometria e se ela não excede a área máxima
		 * permitida. Chamada pelo componente pai antes de efetuar a busca por informações.
		 */
		validar (callback) {

			this.erro = null;

			if (!this.geometria) {

				if (this.tipoGeometria.codigo !== TipoGeometria.PONTO.codigo) {
				
					this.erro = 'É necessário vetorizar uma geometria.';

				} else {
				
					this.erro = 'É necessário marcar um ponto no mapa.';
				}

				return;
			}

			if (this.tipoGeometria.codigo === TipoGeometria.POLIGONO.codigo &&
					this.geometria.area > this.maxAreaHA) {

				this.erro = 'O polígono excede o limite máximo de ' + this.maxAreaHA + ' ha';
				return;
			}

			if (callback) callback();
		},

		/**
		 * Limpa todas as informações do componente, retornando-o a seu estado inicial.
		 */
		limpar () {

			this.removerGeometriasMapa();
			this.geometria = null;
			this.erro = null;

			this.$nextTick().then(() => {
				this.validacaoExecutada = false;
				this.$validator.cleanErrors();
			});
		},

		/**
		 * Retorna a geometria vetorizada. Método utilizado pelo componente pai para
		 * efetuar a busca por informações.
		 */
		getGeometria () {
			return this.geometria;
		}
	}
};

</script>

<style lang="scss" scoped>


</style>


// WEBPACK FOOTER //
// InspecaoGeometria.vue?117dfea7